import $ from 'jquery';

// #/de/oberharz/default/search/Event/
//  category:"Kinderprogramm"
//  category:"Sport-_-Freizeit"
//  mode:next_months,3
//  sort:chronological
//  winter (search text)

// #/de/oberharz/default/search/Event/
//  category:%22Ausflugsfahrten%22
//  category:%22Geselligkeit-_-Spiele-_-Treffen%22
//  category:%22Kinderprogramm%22
//  category:%22Sport-_-Freizeit%22
//  mode:this_weekend  ("mode:today" or "mode:date,2023-12-15T00:00:00+01:00,2023-12-19T00:00:00+01:00")
//  radius:48000  (max is 50000, and it's omitted)
//  sort:chronological ("sort:distance", "sort:rating_damas_percent%20desc,relevance")
//  winter (search text)

// wiederkehrende ausblenden: "recur:-frequently_recurring"

// DEFAULT:  mode:mode:next_months,3/sort:chronological

/**
 * @param {Date} date
 * @returns {string}
 */
function simpleIsoDate(date) {
    let zfill = (num) => num.toString().padStart(2, '0');
    let dateString = date.getFullYear() + '-' + zfill(date.getMonth() + 1) + '-' + zfill(date.getDate());
    return `${dateString}T00:00:00+01:00`;
}

function extractDate(input) {
    if (!input._airDatepickerInstance) {
        return null;
    }
    return input._airDatepickerInstance.selectedDates[0] || null;
}

$('.filter-events').each((i, elem) => {
    const $root = $(elem);
    const $form = $root.find('.filter-events__form');
    const baseUrl = $root.attr('data-base-url');
    const target = $form.attr('target') || '_self';

    $form.on('submit', ev => {
        ev.preventDefault();
        let inputs = $form.serializeArray();

        let params = [];
        params.push('mode:next_months,3');
        params.push('sort:chronological');

        let startDate = null;
        let endDate = null;

        inputs.forEach(input => {
            let realInput = $form.find(`[name="${input.name}"]`)[0];

            if (input.value) {
                if (input.name === 'location') {
                    if (input.value !== '' && input.value !== 'all') {
                        input.value.split('/').forEach(v => {
                            let [key, latlng] = v.split(':');
                            params.push(`${key}:${encodeURIComponent(latlng)}`);
                        });
                        params.push('radius:3000');
                    }
                } else if (input.name === 'category') {
                    if (input.value !== '' && input.value !== 'all') {
                        params.push(`${input.name}:"${encodeURIComponent(input.value)}"`);
                    }
                } else if (input.name === 'start-date') {
                    startDate = extractDate(realInput);
                } else if (input.name === 'end-date') {
                    endDate = extractDate(realInput);
                    endDate.setDate(endDate.getDate() + 1); // so the end day is included
                } else {
                    params.push(`${input.name}:${encodeURIComponent(input.value)}`);
                }
            }
        });

        // mode:date,2023-12-15T00:00:00+01:00,2023-12-19T00:00:00+01:00
        if (startDate && !endDate) {
            endDate = new Date(startDate);
            endDate.setMonth(endDate.getMonth() + 12);
        } else if (endDate && !startDate) {
            startDate = new Date();
        }

        if (startDate && endDate) {
            params.push(`mode:date,${simpleIsoDate(startDate)},${simpleIsoDate(endDate)}`);
        }

        const fullUrl = `${baseUrl}#/de/oberharz/default/search/Event/${params.join('/')}`;
        const link = document.createElement('a');
        link.href = fullUrl;
        link.target = target;

        if (
            link.origin === window.location.origin
            && link.pathname === window.location.pathname
        ) {
            const $iframe = $('iframe#et4pages_iframe');
            if ($iframe.length > 0) {
                $iframe.attr('src', `https://pages.destination.one/de/oberharz/default/search/Event/${params.join('/')}`);
            } else {
                window.location.href = fullUrl;
                window.location.reload();
            }
        } else {
            link.click();
        }
    });

});
